<template>
    <div :class="classNamesElement">
        <label v-if="label" :for="id"><translate>{{ label }}</translate></label>
        <div class="form-element--checkbox">
            <input class="form-input" type="checkbox" :name="name" :id="id" :value="value" v-model="proxyChecked" :required="required" :disabled="disabled">
            <label :for="id" class="form-option" v-html="option" />
            <span v-if="errorOrInfo" class="form-info">{{ errorOrInfo }}</span>
        </div>
    </div>
</template>

<script>
export default {
    name: 'FormCheckbox',
    props: {
        checked: {
            type: [Boolean, Array],
            default: false,
        },
        value: {
            default: null,
        },
        id: {},
        name: {},
        label: {},
        required: {},
        option: {},
        disabled: {},
        error: {},
    },
    emits: ['update:checked'],
    computed: {
        proxyChecked: {
            get() {
                return this.checked;
            },
            set(val) {
                this.$emit('update:checked', val);
            },
        },
        classNamesElement() {
            let classNames = ['form-element'];
            if (this.error) classNames.push('form-element--error');

            return classNames;
        },
        errorOrInfo() {
            return this.error ? this.error : '';
        },
    },
};
</script>
